import React, { useContext, useEffect } from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { SocketContext } from './AutobahnSocket';

const PrivateRoute = ({component: Component, ...rest}) => {
    const context = useContext(SocketContext)
    const location = useLocation()

    useEffect(() => {
        if (location.pathname === '/logout')
            return
        localStorage.setItem('url', location.pathname + location.search)  // location.pathname + location.search
    },[location.pathname, location.search])
 
    return (
        <Route {...rest} render={props => (
            context.session ?
                <Component {...props} />
            : <Redirect to="/" />
        )} />
    );
};

export default PrivateRoute;